import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import {
  Grid, Stack, Typography, Button, Link, Tabs, Box, Tab,
} from '@mui/material';
import React from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { styled } from '@mui/material';
import Image from 'next/image';

interface GoyoloArticleItemProps {
  title: string;
  iconUrl: string;
  linkUrl: string;
}

const StyledTab = styled(Tab)`
  max-width: 260px;
  box-shadow: 0px 2px 10px rgba(7, 65, 57, 0.15);
  border-radius: 6px;
  margin-left: 12px;
  overflow: hidden;
  padding: 0;
  height: 200px;
  margin-top: 10px;
  background: #ffffff;
  margin-bottom: 4px;
  text-transform: inherit;
  cursor: inherit;
`;

const GoyoloArticleItem: React.FC<GoyoloArticleItemProps> = ({
  title,
  iconUrl,
  linkUrl,
}) => (
  <Stack
    spacing={pr`8px`}
    alignItems="center"
    sx={{
      maxHeight: '200px',
      minWidth: '260px',
      boxSizing: 'border-box',
    }}
  >
    <Image
      src={iconUrl}
      alt="banner"
      width={122}
      height={50}
      objectFit="contain"
    />

    <Typography
      variant="title"
      fontWeight="500"
      color={style.color.black1}
    >
      {title}
    </Typography>
    <Stack
      justifyContent="center"
      alignItems="center"
      marginLeft="8px!important"
    >
      <Link
        sx={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
        }}
        href={linkUrl}
        target="_blank"
        rel="nofollow, noindex"
      >

        <Typography
          variant="contentRegular"
          color={(theme) => theme.palette.product3}
          fontWeight="700"
        >
          Đọc thêm
        </Typography>
        <KeyboardArrowRightIcon
          sx={{
            color: (theme) => theme.palette.product3,
            background: 'white!important',
          }}
        />

      </Link>
    </Stack>
  </Stack>
);

const GoyoloArticle = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={pr`22px`}
    >
      <Typography
        component="h2"
        fontWeight="500"
        variant="heading1"
      >
        Những bài báo về VeXeRe - Công ty chủ quản của Goyolo
      </Typography>
      <Grid container>
        <Grid
          item
          xs={12}
          marginLeft={{
            xs: '-8px!important',
            sm: 0,
          }}
          md={12}
        >
          <Box sx={{}}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              sx={{
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
                '& .MuiSvgIcon-root': {
                  background: '#EFF2F5',
                  borderRadius: '50%',
                  padding: '6px',
                },
                '& .Mui-disabled': {
                  display: 'none',
                },
              }}
              aria-label="scrollable force tabs example"
            >
              <StyledTab
                label={(
                  <GoyoloArticleItem
                    iconUrl="https://storage.googleapis.com/goyolo-production/news-vtv.png"
                    title="VeXeRe - Hệ thống vé xe lớn nhất Việt Nam"
                    linkUrl="https://www.youtube.com/watch?v=du_TpvYVNg0"
                  />
                )}
              />
              <StyledTab
                label={(
                  <GoyoloArticleItem
                    iconUrl="https://storage.googleapis.com/goyolo-production/news-tuoitre.png"
                    title="Quỹ đầu tư Nhật và Singapore đầu tư vào VeXeRe"
                    linkUrl="https://tuoitre.vn/blog/quy-dau-tu-nhat-va-singapore-tiep-suc-vexerecom-767367.htm"
                  />
                )}
              />
              <StyledTab
                label={(
                  <GoyoloArticleItem
                    iconUrl="https://storage.googleapis.com/goyolo-production/news-dantri.png"
                    title="VeXeRe gọi vốn thành công từ ba nhà đầu tư châu Á"
                    linkUrl="https://dantri.com.vn/kinh-doanh/cong-ty-co-phan-ve-xe-re-goi-von-thanh-cong-tu-cac-nha-dau-tu-uy-tin-20191225100127703.htm"
                  />
                )}
              />
              <StyledTab
                label={(
                  <GoyoloArticleItem
                    iconUrl="https://storage.googleapis.com/goyolo-production/news-vnexpress.png"
                    title="Vexere hỗ trợ 5.000 vé Tết 2021 cho sinh viên"
                    linkUrl="https://vnexpress.net/vexere-ho-tro-5-000-ve-tet-2021-cho-sinh-vien-4211920.html"
                  />
                )}
              />

            </Tabs>
          </Box>

        </Grid>
      </Grid>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Button sx={{}}>
          <Link
            sx={{
              display: 'flex',
              textDecoration: 'none',
            }}
            href="https://blog.vexere.com/"
            target="_blank"
            rel="nofollow, noindex"
          >

            <Typography
              variant="contentRegular"
              color={(theme) => theme.palette.product3}
              fontWeight="400"
            >
              Xem thêm
            </Typography>
            <KeyboardArrowRightIcon
              sx={{ color: (theme) => theme.palette.product3 }}
            />

          </Link>
        </Button>
      </Stack>
    </Stack>
  );
};

export default GoyoloArticle;
